import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import { Toaster } from './components/ui/toaster';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ThoughtLeadership from './pages/ThoughtLeadership';
import Lounge from './pages/Lounge';
import LoungePost from './pages/LoungePost';
import SpeakerKit from './pages/SpeakerKit';
import Testimonials from './pages/Testimonials';
import Admin from './pages/Admin';
import AIWorkflowAutomation from './pages/AIWorkflowAutomation';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <BookingModal />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BookingProvider>
          <ScrollToTop />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/ai-workflow-automation" element={<AIWorkflowAutomation />} />
              <Route path="/thought-leadership" element={<ThoughtLeadership />} />
              <Route path="/speaker-kit" element={<SpeakerKit />} />
              <Route path="/lounge" element={<Lounge />} />
              <Route path="/lounge/:slug" element={<LoungePost />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Chrome>
          <Toaster />
        </BookingProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
